import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';

const HealthContextSection = ({ healthContextSnapshot }) => {
  const { t } = useTranslation();

  if (!healthContextSnapshot) {
    return null;
  }

  const { demographics, recentMetrics, conditions, allergies, medications, labResults } = healthContextSnapshot;

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#333' }}>
        {t('healthContext')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
            {t('demographics')}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('age')}: {demographics?.age || t('notSpecified')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('gender')}: {demographics?.gender || t('notSpecified')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('weight')}: {demographics?.weight || t('notSpecified')} {t('kg')}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('height')}: {demographics?.height || t('notSpecified')} {t('m')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
            {t('healthProfile')}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('conditions')}: {conditions?.length || 0}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('allergies')}: {allergies?.length || 0}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('medications')}: {medications?.length || 0}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              {t('labResult')}: {labResults?.length || 0}
            </Typography>
          </Box>
        </Grid>
        {recentMetrics && (
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#333' }}>
              {t('recentMetrics')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" sx={{ color: '#666' }}>
                {t('bloodPressure')}: {recentMetrics.bloodPressure || t('notAvailable')}
              </Typography>
              <Typography variant="body2" sx={{ color: '#666' }}>
                {t('heartRate')}: {recentMetrics.heartRate || t('notAvailable')}
              </Typography>
              <Typography variant="body2" sx={{ color: '#666' }}>
                {t('glucose')}: {recentMetrics.glucose || t('notAvailable')}
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default HealthContextSection;
